import { createContext, useContext, useEffect, useState } from 'react';

const SessionContext = createContext();

const SESSION_DURATION = 30 * 60 * 1000; // session expires after 30 minutes of inactivity

export const SessionProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const initializeSession = () => {
      const storedSessionId = sessionStorage.getItem('sessionId');
      const storedTimestamp = sessionStorage.getItem('sessionTimestamp');
      const now = Date.now();

      // check if session exists hasn't expired
      if (storedSessionId && storedTimestamp) {
        const sessionAge = now - parseInt(storedTimestamp, 10);

        // if session hasn't expired, update timestamp to extend session
        if (sessionAge < SESSION_DURATION) {
          setSessionId(storedSessionId);
          sessionStorage.setItem('sessionTimestamp', now.toString());
          return;
        }
      }

      // create new session if none exists or has expired
      const newSessionId = crypto.randomUUID();
      sessionStorage.setItem('sessionId', newSessionId);
      sessionStorage.setItem('sessionTimestamp', now.toString());
      setSessionId(newSessionId);
    };

    initializeSession();

    // update timestamp on any user activity to keep session alive
    const updateActivity = () => {
      const storedSessionId = sessionStorage.getItem('sessionId');
      if (storedSessionId) {
        sessionStorage.setItem('sessionTimestamp', Date.now().toString());
      }
    };

    // listen for user activity
    window.addEventListener('click', updateActivity);
    window.addEventListener('keydown', updateActivity);
    window.addEventListener('scroll', updateActivity);

    return () => {
      window.removeEventListener('click', updateActivity);
      window.removeEventListener('keydown', updateActivity);
      window.removeEventListener('scroll', updateActivity);
    };
  }, []);

  return <SessionContext.Provider value={{ sessionId }}>{children}</SessionContext.Provider>;
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within SessionProvider');
  }
  return context;
};
